import React, { useEffect, useState } from 'react';
import feat_icon from '../../assets/imgs/icons/feat-icon.png';
import ContactForm from './ContactForm';
import { useTranslation } from 'react-i18next';
import check from '../../assets/imgs/icons/check.png';
import './ContactPage.scss';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';
// import { useHistory } from 'react-router-dom';
import packages_detailes from '../../apis/home-api/packages_detailes';
// import MianAppBar from '../../components/main-app-bar/MianAppBar';
import Fade from 'react-reveal/Fade';
import { useHistory } from 'react-router';
import { Helmet } from 'react-helmet-async';

const ContactPage = (props) => {
  const { t, i18n } = useTranslation();
  DocTitleScrollTop();
  const history = useHistory();
  const data = history.location.state;

  const [aboutUsData, setAboutUs] = useState([]);
  // useEffect(() => {
  //   if (!history?.location?.state?.selectedPakage) {
  //     history.push('/');
  //   }
  //   // console.log(history.location.state);
  // }, [history?.location?.state?.selectedPakage, history]);
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const fetchedData = await packages_detailes(i18n.language);
        if (!fetchedData) {
        } else {
          setAboutUs(fetchedData);
        }
      } catch (error) {}
    };
    fetchCategory();
  }, [i18n.language]);

  const renderAboutUs = () => {
    return (
      <>
        {aboutUsData?.length > 0 &&
          aboutUsData.map((item) => (
            <div className="single-features" key={item.id}>
              <div className="feature-title">
                <div className="title-icon">
                  <img src={`http://websiteapi.fatoorah.sa/${item.icon}`} alt="feat_icon" />
                </div>
                <div style={{ cursor: 'pointer' }}>
                  <a target="_blank" rel="noreferrer" href={item?.link}>
                    <p>{item.title}</p>
                  </a>
                </div>
              </div>
              {renderDetailes(item.details)}
            </div>
          ))}
      </>
    );
  };
  const renderDetailes = (details) => {
    return (
      details?.length > 0 &&
      details.map((item) => (
        <div className={`feature-item`} key={item.id}>
          <div className="icon-correct">
            <img src={check} alt="" />
          </div>
          <div>
            <p>{item.description}</p>
          </div>
        </div>
      ))
    );
  };
  return (
    <Fade delay={50}>
      <>
        {/* <MianAppBar /> */}
        <div className={`conact-section ${i18n.dir()}`}>
          <div className="custom-container">
            <div className="main-wrapper">
              <div className="hero-text">
                <div className="small-box">
                  <div className="section-header">
                    <div className="icon">
                      <img src={feat_icon} alt="feat-icon" />
                    </div>
                    <div>
                      <h3 className="title">{t('Offers_section.sub_title')}</h3>
                    </div>
                  </div>
                  <div className="Offers-item-features">{renderAboutUs()}</div>
                </div>
              </div>
              <div className="hero-img">
                <ContactForm selectedData={data} />
              </div>
            </div>
            <div className="hero-footer"></div>
          </div>
        </div>
      </>
    </Fade>
  );
};

export default ContactPage;
